export default "__VITE_ASSET__CLtZC39l__"